import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { InstallationStatusPluginService } from './status.service';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../../../modal/confirm.component';
import * as _ from 'lodash';

@Component({
    selector: 'installation-status-edit',
    templateUrl: './status-edit.component.html',
    standalone: false
})
export class InstallationStatusEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  statusTypes: any[];
  public currentItem: any;

  @ViewChild('statusTypesModal', { static: true }) statusTypesModal: ModalComponent;
  @ViewChild('statusValueDeleteConfirm', { static: true }) statusValueDeleteConfirm: ConfirmComponent;

  private statusToRemove: number;
  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationStatusPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['statuses'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateStatus(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public add() {
    this.formData.push(this.initStatus());
  }

  public remove(e: any) {
    this.formData.removeAt(this.statusToRemove);
  }

  public onClose(e: any) {
    this.currentItem.controls['Status'].markAsTouched();
  }

  public selectStatusMenu(item: any) {
    const selectedIndex = this.currentItem.controls['Status'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['Status'].setValue(selectedIndex);
  }

  public openStatusSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.statusTypesModal, this.statusTypes, selectedIndex ?? -1);
    this.currentItem = this.formData.controls[i];
  }

  public openStatusValueDeleteConfirm(i: number) {
    this.statusValueDeleteConfirm.open();
    this.statusToRemove = i;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.statusTypes = this.pluginService.getStatusTypes();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      statuses: this.fb.array([])
    });
    _.forEach(this.plugin.config.Statuses, (el) => {
      this.formData.push(this.initStatus(el));
    });
  }

  private initStatus(el?: any) {
    return this.fb.group({
      Label: new UntypedFormControl(el?.Label ?? ''),
      Status: new UntypedFormControl(el?.Status ? parseInt(el.Status) : -1)
    });
  }
}
